import { render, staticRenderFns } from "./Mandatory_sign.vue?vue&type=template&id=5b6b57e4&scoped=true&"
import script from "./Mandatory_sign.vue?vue&type=script&lang=js&"
export * from "./Mandatory_sign.vue?vue&type=script&lang=js&"
import style0 from "./Mandatory_sign.vue?vue&type=style&index=0&id=5b6b57e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b57e4",
  null
  
)

export default component.exports